module.exports = __webpack_public_path__ + "static/media/_british-antarctic-territory.df4296db.png";